import React from 'react';
import FormTitleStrip from './FormTitleStrip';

/**
 * Whether a step after the first draws its title strip (owner call 2026-10-21): everywhere but
 * the mobile drawer, which has no strip of ours — there the step keeps its Back at the bottom.
 * One rule for every step, so the embedded card, the hosted page and the overlay all match.
 */
export const stepHasTitleStrip = ({ isDrawerOpen }) => !isDrawerOpen;

/** The step body's frame per display mode: the card body, or the drawer's full-height ground. */
export function stepBodyClass({ isDrawerOpen, formDisplayMode }) {
  if (isDrawerOpen) return 'h-full rounded-none justify-center bg-[color:var(--cs-surface-0)]';
  if (formDisplayMode === 'overlay') return 'cs-form-card-body flex-1';
  return 'cs-form-card-body';
}

/**
 * A form step after the first (the questions step, the monthly upsell): its title strip with
 * Back, then its body, framed the same way in every display mode (FormTitleStrip + the card
 * body). The step draws its own bottom Back only where `stepHasTitleStrip` is false.
 */
export default function FormStepFrame({
  title,
  onBack,
  backDisabled = false,
  headerId,
  isDrawerOpen = false,
  formDisplayMode = 'dynamic',
  bodyClassName = '',
  bodyStyle,
  children,
}) {
  return (
    <>
      {stepHasTitleStrip({ isDrawerOpen }) && (
        <div className="w-full">
          <FormTitleStrip id={headerId} onBack={onBack} backDisabled={backDisabled}>
            {title}
          </FormTitleStrip>
        </div>
      )}
      <div
        className={`${stepBodyClass({ isDrawerOpen, formDisplayMode })} ${bodyClassName}`.trim()}
        style={{ minHeight: 0, ...(isDrawerOpen ? { padding: '0' } : {}), ...bodyStyle }}
      >
        {children}
      </div>
    </>
  );
}
